var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{staticClass:"table-sort-input",attrs:{"value":_vm.value,"min":0,"step":1,"size":"mini","controls-position":"right"},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }